import type { ReplyClassification } from '../../api/emailThreads';

export interface ClassificationStyle {
  label: string;
  bg: string;
  color: string;
  icon: string;
}

export const CLASSIFICATION_LABELS: Record<ReplyClassification, ClassificationStyle> = {
  buying_ready:   { label: 'Kaufbereitschaft', bg: '#d4edda', color: '#155724', icon: '€' },
  interested:     { label: 'Interesse',        bg: '#e8f5e9', color: '#2e7d32', icon: '✓' },
  not_interested: { label: 'Kein Interesse',   bg: '#ffebee', color: '#c62828', icon: '✕' },
  question:       { label: 'Rückfrage',        bg: '#fff3e0', color: '#e65100', icon: '?' },
  unclear:        { label: 'Unklar',           bg: 'var(--surface2)', color: 'var(--text3)', icon: '·' },
};

// Reihenfolge für Dropdowns (wichtig: buying_ready zuerst)
export const CLASSIFICATION_ORDER: ReplyClassification[] = [
  'buying_ready', 'interested', 'question', 'not_interested', 'unclear',
];
